import { keysToCamel, normalizeListPage } from './wireCase';

/**
 * Ver4 標準 list envelope：{ message, route, list, page } → camelCase data + page。
 */
export function parseVer4ListResponse(raw) {
  return {
    message: raw.message,
    route: raw.route,
    data: keysToCamel(raw.list ?? []),
    page: normalizeListPage(raw.page ?? {}),
  };
}

/**
 * Ver4 標準 detail envelope：{ message, route, data } → camelCase data。
 */
export function parseVer4DetailResponse(raw) {
  return {
    message: raw.message,
    route: raw.route,
    data: keysToCamel(raw.data ?? {}),
  };
}

/**
 * Ver4 樹狀 envelope：{ message, route, list } → camelCase data（無 page）。
 */
export function parseVer4TreeResponse(raw) {
  return {
    message: raw.message,
    route: raw.route,
    data: keysToCamel(raw.list ?? []),
  };
}

/**
 * 預設 list fallback：{ list, page } → { data, page }。
 */
export function parseDefaultListResponse(raw) {
  return {
    data: keysToCamel(raw.list ?? []),
    page: normalizeListPage(raw.page ?? {}),
  };
}

/**
 * 預設 detail fallback：{ data } → { data }。
 */
export function parseDefaultDetailResponse(raw) {
  return { data: keysToCamel(raw.data ?? {}) };
}

/**
 * 登入 response（供 SP-11 auth/login.js 使用）。
 * Ver4 envelope，data 內含 token / 使用者資訊。
 */
export function parseLoginResponse(raw) {
  return {
    message: raw.message,
    route: raw.route,
    data: keysToCamel(raw.data ?? {}),
  };
}
